<div class="gs-admin-shell">
    <div class="gs-admin-shell__header">
        <h1 class="text-lg font-semibold text-gray-700">{{ 'grikySkills.admin.title' | translate }}</h1>
        <div class="hidden gs-admin-shell__tabs">
            <button
                *ngFor="let tab of tabs"
                [class.active]="currentTab === tab.id"
                (click)="selectTab(tab.id)"
                class="gs-admin-shell__tab-btn">
                <span>{{ tab.icon }}</span>
                <span>{{ tab.label }}</span>
            </button>
        </div>
    </div>
    <div class="gs-admin-shell__content mt-6">
        <router-outlet></router-outlet>
    </div>
</div>
